
import React from 'react';
import { X, MessageSquare } from 'lucide-react';
import { siteConfig } from '../../config/site';

interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BookingModal: React.FC<BookingModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/90 backdrop-blur-xl transition-opacity duration-500"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="relative bg-secondary border border-accent/20 max-w-sm w-full p-8 sm:p-12 shadow-2xl animate-in zoom-in-95 duration-300">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-white/40 hover:text-accent transition-colors p-2"
        >
          <X size={24} />
        </button>

        <div className="text-center">
          <h2 className="text-2xl font-serif font-bold text-white uppercase tracking-widest mb-2">SECURE YOUR SPOT</h2>
          <div className="w-12 h-px bg-accent/30 mx-auto mb-10"></div>
          
          <div className="space-y-6">
            <a 
              href={`sms:${siteConfig.phone}`}
              className="flex items-center justify-center gap-4 w-full py-5 bg-accent text-black font-black uppercase tracking-[0.2em] text-[11px] hover:bg-white transition-all shadow-xl group"
            >
              <MessageSquare size={18} className="group-hover:scale-110 transition-transform" />
              Text Santi
            </a>
          </div>

          <p className="mt-10 text-[9px] text-white/30 uppercase tracking-[0.3em] font-bold">
            House Calls • South Florida • Elite Grooming
          </p>
        </div>

        {/* Aesthetic Corners */}
        <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-accent/20 pointer-events-none"></div>
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-accent/20 pointer-events-none"></div>
      </div>
    </div>
  );
};

export default BookingModal;
